import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { FormTextarea } from "../../components/FormTextarea";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { AlertService } from "../../utility/service/alert-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import {
  F1040502Before,
  F1040503Before,
  createBoudaryDevice,
  updateBoudaryDevice,
} from "../../utility/service/boundaryDevice-service";
import {
  CreateSubTypeDevice,
  queryClassNoTypeList,
  queryClassProcessList,
  queryMaterialList,
  querySubTypeDeviceList,
} from "../../utility/service/carbon-service";
import { Base64Encoder, BcryptEncoder, checkDpSuccess, getFormErrorMessage } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";

const BoundaryDeviceDetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { itemObj, companyName, tabAction, setTabAction, placeList, currentCompanySeq } = useOutletContext();
  const isEditable = useEditableFlag("F10405"); // control edit by F10103
  const [action, setAction] = useState(""); //設定當前是做哪個動作(CRUD)
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [classList, setClassList] = useState([]);
  const [materialCodeList, setMaterialCodeList] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [enableFlagList, setEnableFlagList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [deviceOwnershipList, setDeviceOwnershipList] = useState([]);
  const [addChecked, setChecked] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [subTypeList, setSubTypeList] = useState([]);
  const [prefix, setPrefix] = useState("");
  const [formRule, setFormRule] = useState([]); //表單驗證
  const detailFlag = tabAction === "detail" || !isEditable;

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  // 設置標記，表示從子頁面返回
  useEffect(() => {
    sessionStorage.setItem("fromBoundaryDeviceChildPage", "true");
  }, []);

  const btnBackTo = () => {
    navigate("/management/boundaryDevice");
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  const axios_F1040502Before = () => {
    F1040502Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const axios_F1040503Before = () => {
    F1040503Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  useEffect(() => {
    if (tabAction === "detail") {
      setAction("edit");
      Object.entries(itemObj).forEach(([key, value]) => {
        setValue(key, value);
      });
      const value = getValues("placeDeviceNo") ?? "";

      // 比對前兩個英文字
      const match = value.match(/^([A-Za-z]{2})(.*)$/);

      if (match) {
        setPrefix(match[1]);
        setValue("placeDeviceNo", match[2]);
      } else {
        setPrefix("");
        setValue("placeDeviceNo", value);
      }

      axios_queryClassNoTypeList(getValues("classNo")).then(setTypeList);
      axios_querySubTypeDeviceList({
        companySeq: currentCompanySeq,
        classNo: getValues("classNo"),
        type: typeList.filter((item) => item.typeSeq === getValues("typeSeq"))[0]?.type,
        subType: getValues("subType"),
      });
      axios_F1040503Before();
    } else if (tabAction === "create") {
      setAction("create");
      reset();
      axios_F1040502Before();
    } else {
      btnBackTo();
    }
    axios_queryClassProcessList({
      class: "C",
    });
    axios_getSubItemsByItemNo("CFV_PLAN_MATERIAL", 13).then(setMaterialTypeList);
    axios_getSubItemsByItemNo("ENABLE_STATUS", 18).then(setEnableFlagList);
    axios_getSubItemsByItemNo("DEVICE_OWNERSHIP", 50).then(setDeviceOwnershipList);
    axios_queryMaterialList();
  }, []);

  useEffect(() => {
    const typeSeq = getValues("typeSeq");

    let mainType = null;
    let subType = null;

    mainType = typeList.find((item) => item.typeSeq === typeSeq);

    if (!mainType) {
      for (const item of typeList) {
        const foundSub = item.subTypeList?.find((sub) => sub.typeSeq === typeSeq);
        if (foundSub) {
          mainType = item;
          subType = foundSub;
          break;
        }
      }
    }

    if (subType) {
      setValue("mainTypeSeq", mainType.typeSeq);
      setValue("subTypeSeq", subType.typeSeq);
      setSubTypeList(mainType.subTypeList);
    } else if (mainType) {
      setValue("mainTypeSeq", mainType.typeSeq);
    }
  }, [typeList]);

  useEffect(() => {
    switch (getValues("classNo")) {
      case "1":
        const filter = typeList.filter((item) => item.typeSeq === getValues("mainTypeSeq"))[0];
        const haveSubType = filter?.subTypeList?.find((item) => item.typeSeq === getValues("subTypeSeq"));
        if (!haveSubType) {
          switch (filter?.type) {
            case "P":
              setPrefix("GM");
              break;
            case "T":
              setPrefix("GV");
              break;
            case "E":
              setPrefix("GS");
              break;
            case "F":
              setPrefix("GF");
              break;
            default:
              setPrefix("");
              break;
          }
        }
        break;
      case "2":
        setPrefix("GP");
        break;
      default:
        setPrefix("");
        break;
    }
  }, [watch("classNo"), watch("mainTypeSeq"), watch("subTypeSeq")]);

  //新增設備
  const axios_CreateSubTypeDevice = () => {
    if (getValues("newEqu") === "") {
      AlertService.ok("", t("validation.required"));
      return;
    }
    CreateSubTypeDevice({
      subType: subTypeList.length <= 0 ? "O" : subTypeList.filter((s) => s.typeSeq === watch("subTypeSeq"))[0]?.subType,
      deviceName: getValues("newEqu"),
      companySeq: currentCompanySeq,
      classNo: getValues("classNo"),
    }).then((res) => {
      if (checkDpSuccess(res)) {
        setValue("deviceCode", res?.data?.RespBody?.deviceCode, {
          shouldValidate: true,
        });
        clearErrors(["deviceCode"]);
        setChecked(false);
        handleSuccessMessage(dispatch, t("button.add") + " " + t("message.success"));
        setValue("newEqu", "");
        axios_querySubTypeDeviceList({
          companySeq: currentCompanySeq,
          classNo: getValues("classNo"),
          type: typeList.filter((item) => item.typeSeq === getValues("typeSeq"))[0]?.type,
          subType: getValues("subType"),
        });
      }
    });
  };

  //設備查詢
  const axios_querySubTypeDeviceList = (reqBody) => {
    querySubTypeDeviceList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        setDeviceList(res?.data?.RespBody?.deviceList);
      }
    });
  };

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  // 原燃物料code清單查詢
  const axios_queryMaterialList = () => {
    queryMaterialList().then((res) => {
      if (checkDpSuccess(res)) {
        setMaterialCodeList(res?.data?.RespBody?.materialList);
      }
    });
  };

  // 範疇/類別 criterion 0-> S ; criterion 1 -> C
  const axios_queryClassProcessList = (reqBody) => {
    queryClassProcessList(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let result = res.data.RespBody;
        setClassList(result?.classList); //類別清單
      }
    });
  };

  // 排放源型式
  const axios_queryClassNoTypeList = (classNo, typeSeq) => {
    return queryClassNoTypeList({ classNo }).then((res) => {
      if (checkDpSuccess(res)) {
        return res.data.RespBody?.typeList ?? [];
      }
      return [];
    });
  };

  const encoder = (dataList, code) => {
    const findItemIndex = (map, code) => {
      return map.get(code) ?? false;
    };
    if (code === null || code === undefined || code === "") return "";
    if (dataList === null || dataList === undefined || dataList === "" || dataList.length <= 0) return "";
    return Base64Encoder(BcryptEncoder(code ?? "")) + "," + findItemIndex(dataList, code ?? "");
  };

  const axios_createBoudaryDevice = (data) => {
    checkLoading(loading);
    const deviceOwnershipMap = new Map(deviceOwnershipList.map((v, i) => [v.subitemNo, v.index]));
    const reqBody = {
      companySeq: currentCompanySeq,
      placeSeq: data.placeSeq,
      placeDeviceNo: data.placeDeviceNo,
      deviceCode: data.deviceCode,
      classNo: data.classNo,
      typeSeq: data.typeSeq,
      materialType: data.materialType,
      materialCode: data.materialCode,
      dept: data.dept,
      location: data.location,
      enableFlag: data.enableFlag,
      deviceOwnership: encoder(deviceOwnershipMap, data.deviceOwnership),
    };
    createBoudaryDevice(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
          btnBackTo();
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  const axios_updateBoudaryDevice = (data) => {
    checkLoading(loading);
    const deviceOwnershipMap = new Map(deviceOwnershipList.map((v, i) => [v.subitemNo, v.index]));
    const reqBody = {
      placeDeviceSeq: data.placeDeviceSeq,
      companySeq: currentCompanySeq,
      placeSeq: data.placeSeq,
      placeDeviceNo: data.placeDeviceNo,
      deviceCode: data.deviceCode,
      classNo: data.classNo,
      typeSeq: data.typeSeq,
      materialType: data.materialType,
      materialCode: data.materialCode,
      dept: data.dept,
      location: data.location,
      enableFlag: data.enableFlag,
      deviceOwnership: encoder(deviceOwnershipMap, data.deviceOwnership),
    };
    updateBoudaryDevice(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          btnBackTo();
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  const onSubmit = (data) => {
    if (action === "create") {
      axios_createBoudaryDevice(data);
    } else {
      axios_updateBoudaryDevice(data);
    }
    setTabAction("");
  };

  return (
    <>
      {/* 上方基本資訊 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
        <div className="align-items-end">{t(`button.${tabAction}`)}</div>
      </div>
      {companyName && (
        <div className="p-card bg-gray">
          <div className="p-card-body">
            <div className="grid">
              <div className="col-12">
                <h3 className="m-0">{companyName}</h3>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="p-card">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)} className="grid">
            {/* 場所 */}
            <div className="col-12">
              <label htmlFor={`placeSeq`} className="form-label required">
                {t("place")}
              </label>
              <Controller
                name={`placeSeq`}
                rules={setValidForm("placeSeq")}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    optionLabel="placeName"
                    optionValue="placeSeq"
                    disabled={detailFlag}
                    value={field.value}
                    options={placeList}
                    placeholder={t("plz_chs")}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(e) => {
                      field.onChange(e.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, `placeSeq`)}
            </div>
            {/* 狀態 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="enableFlag" className="form-label required">
                {t("status")}
              </label>
              <Controller
                name="enableFlag"
                control={control}
                rules={setValidForm("enableFlag")}
                render={({ field, fieldState }) => (
                  <Dropdown
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    disabled={detailFlag}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="enableFlag"
                    control={control}
                    options={enableFlagList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/* 邊界所有權 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="deviceOwnership" className="form-label">
                {t("boundaryOwnership")}
              </label>
              <Controller
                name="deviceOwnership"
                control={control}
                rules={setValidForm("deviceOwnership")}
                render={({ field, fieldState }) => (
                  <Dropdown
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    disabled={detailFlag}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="deviceOwnership"
                    control={control}
                    options={deviceOwnershipList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/* 類別/範疇 */}
            <div className="col-12">
              <label htmlFor={`classNo`} className="form-label required">
                {t("category")}
              </label>
              <Controller
                name={`classNo`}
                rules={{
                  required: { value: true, message: t("validation.required") },
                }}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    optionLabel="className"
                    optionValue="classNo"
                    disabled={detailFlag}
                    value={field.value}
                    options={classList}
                    placeholder={t("plz_chs")}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(e) => {
                      field.onChange(e.value);
                      axios_queryClassNoTypeList(e.value).then(setTypeList);
                      setValue("mainTypeSeq", "", { shouldValidate: true });
                      setValue("subTypeSeq", "", { shouldValidate: true });
                      setValue("deviceCode", "", { shouldValidate: true });
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, `classNo`)}
            </div>
            {/* 排放源型式 */}
            <div className={`col-12 ${subTypeList.length > 0 ? "lg:col-6" : "lg:col-12"}`}>
              <label htmlFor={`mainTypeSeq`} className="form-label required">
                {t("emission_source_type")}
              </label>
              <Controller
                name={`mainTypeSeq`}
                rules={{
                  required: { value: true, message: t("validation.required") },
                }}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    optionLabel="typeName"
                    optionValue="typeSeq"
                    disabled={detailFlag}
                    value={field.value}
                    options={typeList}
                    placeholder={t("plz_chs")}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(e) => {
                      field.onChange(e.value);
                      const filter = typeList.filter((item) => item.typeSeq === e.value)[0];
                      axios_querySubTypeDeviceList({
                        companySeq: currentCompanySeq,
                        classNo: getValues("classNo"),
                        type: filter?.type,
                        subType: getValues("subType"),
                      });
                      setSubTypeList(filter?.subTypeList ?? []);
                      if ((filter?.subTypeList ?? []).length <= 0) {
                        setValue("typeSeq", e.value);
                      }
                      setValue("subTypeSeq", null);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, `mainTypeSeq`)}
            </div>
            {/* 排放源Sub型式 如果 typeSeq 的 subTypeList 有值才出現 */}
            {subTypeList.length > 0 && (
              <div className="col-12 lg:col-6">
                <label htmlFor="subTypeSeq" className="form-label required">
                  {t("type")}
                </label>
                <Controller
                  name="subTypeSeq"
                  control={control}
                  rules={{
                    required: {
                      value: subTypeList.length > 0,
                      message: t("validation.required"),
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      optionLabel="typeName"
                      optionValue="typeSeq"
                      disabled={detailFlag}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name={t("type")}
                      control={control}
                      options={subTypeList}
                      className={`w-full mr-2` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(e) => {
                        field.onChange(e.value);
                        setValue("typeSeq", e.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, `subTypeSeq`)}
              </div>
            )}
            {/* 設備編號 */}
            <div className="col-12 lg:col-6">
              <label className="form-label required" htmlFor="placeDeviceNo">
                {t("placeDeviceNo")}
              </label>
              <div className="flex align-items-center">
                {prefix && <span className="mr-2">{prefix}</span>}
                <FormInput
                  register={register}
                  errors={errors}
                  disabled={detailFlag}
                  id="placeDeviceNo"
                  name="placeDeviceNo"
                  rules={setValidForm("placeDeviceNo")}
                  wrapperClass="w-full"
                />
              </div>
            </div>
            {/* 設備/服務 */}
            <div className="col-12 sm:col-6">
              <label htmlFor="deviceCode" className="form-label">
                {t("equipment")}
              </label>
              <div className="flex gap-2 align-items-center flex-wrap lg:flex-nowrap">
                <div className="flex gap-2 align-items-center">
                  <Checkbox
                    inputId="add"
                    disabled={detailFlag}
                    onChange={(e) => {
                      setValue("newEqu", null, { shouldValidate: true });
                      setChecked(e.checked);
                      if (!e.checked) {
                        clearErrors(["newEqu"]);
                      }
                    }}
                    checked={addChecked}
                  ></Checkbox>
                  {/* className='white-space-nowrap' */}
                  <label htmlFor="add" className="white-space-nowrap">
                    {t("button.add")}
                  </label>
                </div>
                <div className="col-additem-checkbox-input">
                  {addChecked ? (
                    <div className="flex gap-2 align-items-center flex-nowrap">
                      <FormInput
                        rules={{
                          required: {
                            value: addChecked,
                            message: t("validation.required"),
                          },
                        }}
                        disabled={detailFlag}
                        register={register}
                        errors={errors}
                        id="newEqu"
                        name="newEqu"
                        type="text"
                        enterClick={(e) => {
                          e.stopPropagation();
                        }}
                      />
                      <Button
                        onClick={(e) => {
                          e.preventDefault();
                          axios_CreateSubTypeDevice();
                        }}
                        disabled={detailFlag}
                        label={t("button.add")}
                        size="small"
                        className="white-space-nowrap"
                      ></Button>
                    </div>
                  ) : (
                    <Controller
                      name="deviceCode"
                      control={control}
                      rules={setValidForm("deviceCode")}
                      render={({ field, fieldState }) => (
                        <div>
                          <Dropdown
                            showClear
                            filter
                            disabled={detailFlag}
                            appendTo={"self"}
                            optionLabel="deviceName"
                            optionValue="deviceCode"
                            value={field.value}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="deviceCode"
                            control={control}
                            options={deviceList}
                            className={`w-full flex-shrink-1 ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                              field.onChange(event.value);
                            }}
                          />
                          <label>{getFormErrorMessage(errors, "deviceCode")}</label>
                        </div>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* 原燃物料類別 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="placeName" className="form-label">
                {t("rawMaterial")}
              </label>
              <Controller
                name="materialType"
                control={control}
                rules={setValidForm("materialType")}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    disabled={detailFlag}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="materialType"
                    control={control}
                    options={materialTypeList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "typeSeq")}
            </div>
            {/* 原燃物料代碼  */}
            <div className="col-12 lg:col-6">
              <label htmlFor="materialCode" className="form-label">
                &nbsp;
              </label>
              <Controller
                name="materialCode"
                control={control}
                rules={setValidForm("materialCode")}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    optionLabel="materialName"
                    optionValue="materialCode"
                    disabled={detailFlag}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="materialCode"
                    control={control}
                    options={materialCodeList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            {/* 設備所屬單位/部門 */}
            <div className="col-12 lg:col-6">
              <FormTextarea
                register={register}
                errors={errors}
                id={`dept`}
                name={`dept`}
                disabled={detailFlag}
                rules={setValidForm("dept")}
                labelText={t("dept")}
                areaClass="w-full"
              />
            </div>
            {/* 設備詳細位置/樓層 */}
            <div className="col-12 lg:col-6">
              <FormTextarea
                register={register}
                errors={errors}
                id={`location`}
                name={`location`}
                disabled={detailFlag}
                rules={setValidForm("location")}
                labelText={t("location")}
                areaClass="w-full"
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
              {tabAction === "detail" && (
                <Button
                  disabled={!isEditable}
                  type="button"
                  label={t("button.edit")}
                  size="small"
                  onClick={() => setTabAction("update")}
                />
              )}
              {(tabAction === "create" || tabAction === "update") && (
                <>
                  <Button
                    disabled={!(isValid && isDirty)}
                    type="submit"
                    label={action === "create" ? t("button.create") : t("button.update")}
                    size="small"
                  />
                  {action !== "create" && (
                    <Button
                      outlined
                      size="small"
                      label={t("button.cancel")}
                      onClick={(e) => {
                        e.preventDefault();
                        clearErrors();
                        setTabAction("detail");
                        reset(itemObj);
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BoundaryDeviceDetail;
